














































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import AsignacionNoSeriado from '@/pantallas/Conecta/PreparacionEquipos/AsignacionNoSeriado.vue';
import AsignacionSeriado from '@/pantallas/Conecta/PreparacionEquipos/AsignacionSeriado.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import ModalRequerimiento from './ModalRequerimiento.vue';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    NavegacionModalCrud,
    FormFieldsContainer,
    DatePicker,
    AsignacionNoSeriado,
    AsignacionSeriado,
    ModalRequerimiento,
  },
})
export default class ModalAsignacion extends Vue {
  @Prop({ default: false }) show: boolean;
  @Prop({
    required: true,
    default: {
      asignumero: '',
      modalidad: '',
      estado: '',
      modalidadid: '',
      asigcreacion_auto: '',
      asigdeta_finalizado: '',
    },
  })
  registroSeleccionado: any;
  @Prop({ required: true, default: {} }) data: any;
  /* misc */
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  dialogConfirmacionGuardar: boolean = false;
  // tituloCabecera: any =
  //   'Detalle Asignación ' + this.registroSeleccionado.asigrequerimiento;
  testt: string = 'test';
  /* event handlers */

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };
  listaClientes: any[] = [];
  listaFlotas: any[] = [];
  tabs: any = null;

  showInfo: boolean = true;

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  created() {}

  mounted() {}

  handleCerrar() {
    this.$emit('cerrar');
  }

  finalizarReq() {
    this.$emit('FinalizarClick', { data: this.data });
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
}
